import { forceJSONString } from "@/utils/strings";

interface FunctionArgumentsProps {
  args: string;
}

export const FunctionArguments = ({ args }: FunctionArgumentsProps) => (
  <div className="rounded-md bg-gray-50 p-3">
    <div className="mb-1 text-xs font-medium text-gray-600">Arguments:</div>
    <pre className="whitespace-pre-wrap break-words font-mono text-xs text-gray-800">
      <code>{forceJSONString(args)}</code>
    </pre>
  </div>
);
